import { IPage } from "../entities/page";
import {
  IBucketCreateRequest,
  IBucketDetailsItem,
  IBucketListItem,
  IBucketPageRequestParams,
  IBucketUpdateRequest,
} from "../entities/bucket";
import { DataService } from "./data-service";
import {
  IEntityUsageHistoryItemResponse,
  IEntityMetricsResponse,
  IEntityUsageHistoryRequest,
} from "api/entities/metrics";
import { metricsServiceHelper } from "./metrics-service-helper";

class BucketService extends DataService {
  constructor() {
    super("bucket", 2);
  }

  getPage(
    requestParams: IBucketPageRequestParams
  ): Promise<IPage<IBucketListItem>> {
    return this.api.get<IPage<IBucketListItem>>(null, requestParams);
  }

  get(bucketId: string): Promise<IBucketDetailsItem> {
    return this.api.get<IBucketDetailsItem>(bucketId, null);
  }

  getMetrics(id: string): Promise<IEntityMetricsResponse[]>;
  getMetrics(ids: string[]): Promise<IEntityMetricsResponse[]>;
  async getMetrics(ids: string | string[]): Promise<IEntityMetricsResponse[]> {
    return metricsServiceHelper.getMetrics(this.api, ids);
  }

  async getUsageHistory(
    params: IEntityUsageHistoryRequest
  ): Promise<IEntityUsageHistoryItemResponse[]> {
    return metricsServiceHelper.getUsageHistory(this.api, params);
  }

  create(request: IBucketCreateRequest) {
    return this.api.post<IBucketListItem>(null, request);
  }

  update(id: string, request: IBucketUpdateRequest) {
    return this.api.put<IBucketListItem>(id, request);
  }

  delete(id: string) {
    return this.api.delete<IBucketListItem>(id);
  }
}

export const bucketService = new BucketService();
